import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Ribbon extends Vue {
  public get ribbonEnv(): string {
    return this.$store.getters.activeProfiles[0];
  }

  public get ribbonEnabled(): boolean {
    return this.$store.getters.ribbonOnProfiles && this.$store.getters.ribbonOnProfiles.includes(this.$store.getters.activeProfiles[0]);
  }
}
